import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));
  
  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));
  
  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
  }));



function NavBar({ itemSearch, setItemSearch }) {
  const handleSearchChange = (e) => {
    setItemSearch(e.target.value);
  }
  return (
    <AppBar 
    position="static"
    style={{backgroundColor: '#221100'}}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <img 
            src={ process.env.PUBLIC_URL + '/assets/logo_webdarw.png' } 
            style={{width: '80px', marginRight: '20px', marginLeft: '0px'}}
            alt="WebdARw Logo"  />
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/WebdARw/webdarw-webapp"
            sx={{
              mr: 1,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.1rem',
              color: 'inherit',
              textDecoration: 'underline overline #FF4400 10px',
            //   textDecorationThickness: '50px',
            }}
          >
            WebdARw
          </Typography>
          <Search sx={{ flexGrow: 1, display: { md: 'flex' } }}>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
              value={itemSearch}
              onChange={handleSearchChange}
            />
          </Search>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NavBar;